import type { SetOptions } from "@capacitor/preferences";
import type { QueryClient } from "@tanstack/react-query";
import { mutationOptions } from "../mutations/mutationOptions";
import { buildGetPreferencesQueryKey } from "./buildGetPreferencesQuery";

const preferencesModule =
	import.meta.env.VITE_CAPACITOR_BUILD === "true"
		? import("@capacitor/preferences")
		: null;

export function buildSetPreferencesMutation(queryClient: QueryClient) {
	return mutationOptions({
		mutationKey: ["capacitor-preferences-set"],
		mutationFn: (options: SetOptions) =>
			preferencesModule
				? preferencesModule.then((m) => m.Preferences.set(options))
				: Promise.reject(new Error("Preferences are not supported")),
		onSuccess: (_, variables) => {
			queryClient.invalidateQueries({
				queryKey: buildGetPreferencesQueryKey({
					key: variables.key,
				}),
			});
		},
	});
}
